var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"font-weight-medium",attrs:{"fixed":"","value":"false","app":""}},[_c('v-col',{staticClass:"text-left caption d-flex flex-row",attrs:{"cols":"12"}},[_c('a',{staticClass:"my-auto text-decoration-none",attrs:{"target":"_blank","href":"#"}},[_vm._v(" "+_vm._s(new Date().getFullYear())+" © Bluzone.")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }